module.exports = __webpack_public_path__ + "media/images/demo-icon-sml-d610c36a.png";